import axios from 'axios';

const module = 'documents';

const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
	myUnreadDocuments: 0
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getMyUnreadDocuments: state => {
		return state.myUnreadDocuments;
	},
};

const actions = {
	asyncFetchData: async (context, payload) => {
		const { sortBy, sortDesc, page, itemsPerPage } = payload.options;
		let url = `${module}`;

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters[`${module}/getSortBy`],
						sortDesc: context.rootGetters[`${module}/getSortDesc`],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: payload.filters ? payload.filters : '',
						search: payload.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {

				context.commit('setItems', res.data.data);
				return res.data.pagination;

			})
			.catch(err => {
				console.log('errore', err);

			});
	},

	fetchMyUnreadDocuments: async (context) => {
		let url = `${module}/my-documents`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setMyUnreadDocuments', res.data.result);
				return res.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	deleteItems: async (context, payload) => {
		let url = `${module}/delete`;

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						query: payload,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data;
			})
			.catch(err => {
				console.log('errore', err.response.status);
				return { error: err.response.status };
			});
	},

	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setMyUnreadDocuments: (state, value) => {
		state.myUnreadDocuments = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
